export interface Column1ViewModelState {
  genericDocPointsListingState: any;
  }
  
  export const initialState: Column1ViewModelState = {
  genericDocPointsListingState: null,
  };